export default __webpack_public_path__ + "static/media/Sutter Buttes Red.d3c41251.jpg";